module.exports = __webpack_public_path__ + "media/flowplayer_v7/skin/icons/flowplayer-7f1e76ab430029d33915b93760a62f36.ttf";